export const REDUCER_KEY_STRUCTURE_EDITOR = 'StructureEditorPage';
export const SET_CURRENT_EDITOR = 'StructureEditorPage/SET_CURRENT_EDITOR';
export const SET_STRUCTURE = 'StructureEditorPage/SET_STRUCTURE';
export const CLEAR_STRUCTURE = 'StructureEditorPage/CLEAR_STRUCTURE';
export const CLEAR_STATE = 'StructureEditorPage/CLEAR_STATE';
// Makes difference only for MarvinJS editor
// import will replace existing structure (if any)
// load will add to existing structure
// For Chemdraw it will always replace, regardless of mode
export const STRUCTURE_INSERT_MODE_IMPORT = 'STRUCTURE_INSERT_MODE_IMPORT';
export const STRUCTURE_INSERT_MODE_LOAD = 'STRUCTURE_INSERT_MODE_LOAD';
